import icons from '@/assets/icons';
import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { Flex, Box, Text } from '@cmpsr/components';
import useIsMobile from '@/hooks/use-is-mobile';

type HeaderProps = {
  label: string;
  subheadlineText?: string;
  children?: React.ReactNode;
  icon: keyof typeof icons;
};

export default function HeaderRisks({ label, children, icon }: HeaderProps) {
  const isMobile = useIsMobile();

  return (
    <Flex marginX="auto" w="100%" justifyContent="space-between" mb={4}>
      <Box>
        <Text variant="text-header-2XL">{label}</Text>
        {children}
      </Box>
      <IconCatch
        icon={icon}
        alt="cancer type icon"
        size={isMobile ? 'l' : 'xl'}
        background="gradient-01"
        fill="white"
        filter="brightness(0) invert(1)"
      />
    </Flex>
  );
}
